import { Theme } from '@mui/material';
import { globalClasses } from 'core/common/constants/global-classes';

export const getPaperOptions = ({ palette }: Theme) => {
  const paperComponents = {
    styleOverrides: {
      root: () => {
        return {
          [`&:has(${globalClasses.listRoot})`]: {
            backgroundImage: 'none',
            backgroundColor: palette.select.mainBackground,
          },
          [`&${globalClasses.autocompletePaper}`]: {
            backgroundColor: palette.select.mainBackground,
            marginTop: '2px',
          },
          [`& ${globalClasses.autocompleteListbox}`]: {
            padding: 0,
          },
        };
      },
    },
  };

  return { paperComponents };
};
